module.exports = __webpack_public_path__ + "static/img/10035.8803cc74.png";